import React from 'react';
import { C } from '../constants.jsx';

export default function NonePanel({ screenW, screenH, screenBg, onScreenChange }) {
  const inputStyle = {
    width: '100%', padding: '7px 9px', fontSize: 12,
    border: `1px solid ${C.border}`, borderRadius: 6,
    color: C.text, background: C.surface, outline: 'none', fontFamily: 'inherit',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ padding: '11px 13px', borderBottom: `1px solid ${C.border}`, flexShrink: 0 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: C.text }}>Properties</span>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: 13 }}>
        <div style={{ color: C.muted, fontSize: 12, textAlign: 'center', marginTop: 24, lineHeight: 1.8 }}>
          Select a component<br />to edit its properties
        </div>

        {/* Canvas settings */}
        <div style={{
          marginTop: 18, padding: '13px 14px',
          background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`,
        }}>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 10 }}>Canvas</div>

          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: 11, color: C.sub, display: 'block', marginBottom: 3 }}>Width (px)</label>
            <input type="number" style={inputStyle} value={screenW}
              onChange={(e) => onScreenChange({ w: +e.target.value })} />
          </div>
          <div style={{ marginBottom: 8 }}>
            <label style={{ fontSize: 11, color: C.sub, display: 'block', marginBottom: 3 }}>Height (px)</label>
            <input type="number" style={inputStyle} value={screenH}
              onChange={(e) => onScreenChange({ h: +e.target.value })} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: C.sub, display: 'block', marginBottom: 3 }}>Background</label>
            <div style={{ display: 'flex', gap: 6 }}>
              <label style={{
                width: 32, height: 32, borderRadius: 6, background: screenBg,
                border: `1px solid ${C.borderMd}`, cursor: 'pointer',
                position: 'relative', flexShrink: 0, overflow: 'hidden', display: 'block',
              }}>
                <input type="color" value={screenBg}
                  onChange={(e) => onScreenChange({ bg: e.target.value })}
                  style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer' }} />
              </label>
              <input style={{ ...inputStyle, fontFamily: 'monospace', fontSize: 12 }}
                value={screenBg} onChange={(e) => onScreenChange({ bg: e.target.value })} />
            </div>
          </div>
        </div>

        {/* Shortcuts */}
        <div style={{
          marginTop: 12, padding: '9px 13px',
          background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`,
          fontSize: 11, color: C.muted, lineHeight: 2,
        }}>
          <div style={{ fontWeight: 700, color: C.sub, marginBottom: 3 }}>Shortcuts</div>
          Delete — remove selected<br />
          ⌘Z / Ctrl+Z — undo<br />
          ⌘D / Ctrl+D — duplicate<br />
          Esc — deselect
        </div>
      </div>
    </div>
  );
}
